import { useTheme } from '@emotion/react';
import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as Quick } from 'assets/icons/quick.svg';
import { fontsize20, poppins600 } from 'theme/common.style';
import QuickSwitchTable from './QuickSwitchTable';

export const QuickSwitch = ({ isShown, setIsShown, buyerregister, vendor }) => {
  const theme = useTheme();
  const isXl = useMediaQuery('(min-width:1200px) and (max-width:1299.98px)');
  const isXxl = useMediaQuery('(min-width:1300px)');
  const isWindowbelow400 = useMediaQuery(theme.breakpoints.down(400));

  const matchesmd = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Card
      sx={{
        p: isWindowbelow400 ? '10px 0 10px 10px' : '10px',
        borderRadius: '5px',
        marginTop: '18px',
        boxShadow: buyerregister && 'none',
        backgroundColor: buyerregister && '#FAFAFA',
        width: isXl ? '98%' : isXxl ? '100%' : '100%',
      }}
    >
      <Grid
        container
        sx={{
          p: !buyerregister ? 2 : null,
          marginTop: '2px',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          height: 'auto',
          width: buyerregister ? '100%' : matchesmd ? '970px' : '90vw',
          position: 'relative',
          flexDirection: 'column',
          backgroundColor: buyerregister && '#FAFAFA',
          ml: isWindowbelow400 && '-20px',
        }}
      >
        <Grid sx={{ justifyContent: 'space-around', alignItems: 'center' }}>
          <Typography sx={{ display: 'flex', alignItems: 'center' }}>
            <Quick style={{ paddingTop: '2px', marginLeft: 10 }} />
            <Typography
              sx={{
                ...poppins600,
                ...fontsize20,
                marginLeft: 1,
                color: '#000000',
              }}
            >
              Quick Switch
            </Typography>
          </Typography>

          <Grid sx={{ padding: '0px 10px' }}>
            <QuickSwitchTable
              isShown={isShown}
              setIsShown={setIsShown}
              buyerregister={buyerregister}
              vendor={vendor}
            />
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
